import {HttpClient} from './HttpClient';
import {API_URL, API_KEY} from '../config/index';


export class Serie {
  private httpClient: HttpClient;

  constructor() {
     this.httpClient = new HttpClient({
       config: {
        baseURL: API_URL,
       }
     });
  }

  public getTrendingSeries = ({payload}: any) => {
    let {range, page } = payload;
    return this.httpClient.get(`/3/trending/tv/${range}?api_key=${API_KEY}&page=${page}`)
  }

    public getVideosForSeries = (id:number) => {
    return this.httpClient.get(`/3/tv/${id}/videos?api_key=${API_KEY}`)
  }

}